import React from 'react'
import { Segment } from 'semantic-ui-react'
import { GridLayoutDiv } from './TranslationReviewPage.js'

const ENCODE_ERROR_MESSAGE =
  'We couldn’t read this file due to encoding. Please save the file as UTF-8/UTF-8-SIG and try again.'
const READING_ERROR_MESSAGE =
  'There was an error reading the CSV file. Please contact customer support.'
const GENERIC_EXPORT_ERROR_MESSAGE = 'Import failed. Please try again or contact support.'

const getDescriptionMessage = (errorMessage) => {
  switch (errorMessage[0]) {
    case ENCODE_ERROR_MESSAGE:
      return 'Save as UTF-8/UTF-8-SIG and try again.'
    case READING_ERROR_MESSAGE:
      return 'Please try again or contact support.'
    default:
      return 'Re-export the CSV and try again.'
  }
}

export default function ImportFailedPage({ errorMessage }) {
  return (
    <>
      <Segment>
        <GridLayoutDiv>
          <i className="col-start-1 fas fa-circle-xmark text-red" />
          {errorMessage.map((msg, index) => (
            <div className="col-start-2 font-bold col-span-full" key={index}>
              {msg === READING_ERROR_MESSAGE ? GENERIC_EXPORT_ERROR_MESSAGE : msg}
            </div>
          ))}
          <div className="col-start-2 mt-2 col-span-full">
            {getDescriptionMessage(errorMessage)}
          </div>
        </GridLayoutDiv>
      </Segment>
    </>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/LanguageImportModal/ImportFailedPage.js